import { isoToFormatDate } from "./formatTime";

const getProgressText = (progress) => {
  const texts = ["未處理", "處理中", "已結案"];
  return texts[Number(progress)];
};

/**
 * Description
 * @param {any} problems: array of Problems
 * @returns {null}
 */
const addSearchedField = (problems) => {
  problems.forEach((problem) => {
    const { reporterId: user } = problem;
    const { memberNumber, name, roomNumber } = user ?? {};
    const shownText = [
      isoToFormatDate(problem.createdAt, "yyyy/MM/dd HH:mm"),
      getProgressText(problem.progress),
      memberNumber,
      name,
      roomNumber,
    ];

    problem.searchedField = shownText.join(" ");
  });
};

export { getProgressText, addSearchedField };
